import React, { useEffect, useState } from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import UnitMeasureSelectMain from '../../../../form/fields/UnitMeasureSelectMain'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MyButton from '../../../../UI/form/MyButton'
import TextFieldMain from '../../../../form/fields/TextFieldMain';
import WriteOffActItemSearch from '../../../forms/fileds/WriteOffActItemSearch';
import WriteOffActItemCountField from '../fields/WriteOffActItemCountField';

const WriteOffActFormItem = ({ index, departmentId, writeOffActItem, setValidate, setValueFormItem, deleteItem, isCanDeleted }) => {

	// const [data, setData] = useState(supplyOrderBd ? supplyOrderBd : {}) // Дані з форми
	const [data, setData] = useState(writeOffActItem ? writeOffActItem : {}) // Дані з форми

	const [positionForWriteOff, setPositionForWriteOff] = useState(null) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	// const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setValidate)
	}, [valid])

	useEffect(() => {
		// console.log('data', data)
		if (data) {
			setValueFormItem(data)
		}
	}, [data])

  return (
    <div className='myFormSimple__listBlock-item'>
		<div className='myFormSimple__listBlock-item-index'>
			{index + 1}
		</div>

		<div className='myFormSimple__listBlock-item-center writeOffActItems__list'>
			{
				formDataProductIsField('supplyBillItemId', 'writeOffActItem') ?
					<WriteOffActItemSearch
						departmentId={departmentId}
						required={formDataProductRequiredField('supplyBillItemId', 'writeOffActItem')}
						setValidate={e => updateValidate(setValid, 'supplyBillItemId', e)}
						setValueForm={e => setValueForm(setData, 'supplyBillItemId', e)}
						forciblyValue={data && data.supplyBillItemId ? data.supplyBillItemId : ''}
						setPositionForWriteOff={setPositionForWriteOff}
						label='Назва'
						placeholder='Введіть назву'
					/>
				: ''
			}
			{
				data.supplyBillItemId ?
					<>
						<div className='myFormSimple__listBlock-item-flex orderForm__item-flex'>
							{
								formDataProductIsField('count', 'writeOffActItem') ?
									<WriteOffActItemCountField
										item={positionForWriteOff}
										data={data}
										required={formDataProductRequiredField('count', 'writeOffActItem')}
										setValidate={e => updateValidate(setValid, 'count', e)}
										setValueForm={e => setValueForm(setData, 'count', e)}
										forciblyValue={
											data && data.count ? data.count : ''
										}
									/>
								: ''
							}
							{/* {
								formDataProductIsField('unitMeasure', 'writeOffActItem') ?
									<UnitMeasureSelectMain
										required={formDataProductRequiredField('unitMeasure', 'writeOffActItem')}
										setValidate={e => updateValidate(setValid, 'unitMeasure', e)}
										setValueForm={e => setValueForm(setData, 'unitMeasure', e)}
										forciblyValue={data && data.unitMeasure ? data.unitMeasure : ''}
									/>
								: ''
							} */}
						</div>
						{
							formDataProductIsField('reason', 'writeOffActItem') ?
								<TextFieldMain
									required={formDataProductRequiredField('reason', 'writeOffActItem')}
									setValidate={e => updateValidate(setValid, 'reason', e)}
									setValueForm={e => setValueForm(setData, 'reason', e)}
									forciblyValue={data && data.reason ? data.reason : ''}
									label='Причина списання'
									multiline={true}
									rows={2}
								/>
							: ''
						}
					</>
				: ''
			}
		</div>
		
		{
			isCanDeleted ?
				<MyButton 
					color='red'
					onClick={deleteItem}
				>
					<HighlightOffIcon />
				</MyButton>
			: ''
		}
	</div>
  )
}

export default WriteOffActFormItem